import React, { useState, useEffect } from 'react';
import { node } from 'prop-types';

export const ResolutionContext = React.createContext({
  isMobile: false,
});

export const ResolutionProvider = ({ children }) => {
  const [isTablet, setIsTablet] = useState(document.querySelector('html').clientWidth <= 1250);
  const [isMobile, setIsMobile] = useState(document.querySelector('html').clientWidth <= 768);

  useEffect(() => {
    window.addEventListener('resize', () => {
      let html = document.querySelector('html');
      let actualWidth = html.clientWidth;

      setIsTablet(actualWidth <= 1250);
      if (actualWidth > 1250) {
        setIsTablet(false);
      } else {
        setIsTablet(true);
      }

      setIsMobile(actualWidth <= 768);
      if (actualWidth > 768) {
        setIsMobile(false);
      } else {
        setIsMobile(true);
      }
    });

    return () =>
      window.removeEventListener('resize', () => {
        let html = document.querySelector('html');
        let actualWidth = html.clientWidth;

        setIsMobile(actualWidth <= 1250);
        if (actualWidth > 1250) {
          setIsMobile(false);
        } else {
          setIsMobile(true);
        }

        setIsMobile(actualWidth <= 768);
        if (actualWidth > 768) {
          setIsMobile(false);
        } else {
          setIsMobile(true);
        }
      });
  }, []);

  return (
    <ResolutionContext.Provider value={{ isMobile: isMobile, isTablet: isTablet }}>
      {children}
    </ResolutionContext.Provider>
  );
};

ResolutionProvider.propTypes = {
  children: node,
};

ResolutionProvider.defaultProps = {
  children: null,
};
